import react, { useState } from "react";
import "./Expenseitem.css"
import ExpenseDate from "./Expensedate"
import Card from "../Card/Card";

function ExpenseItem(props) {

    return (
        <li>
            < Card className="expense-item" >
                <ExpenseDate date={props.date}></ExpenseDate>

                <div className="expense-item__description">

                    <h2>{props.title}</h2>
                    <div className="expense-item__price">${props.amount}</div>
                </div>

            </Card >
        </li>
    );
}
export default ExpenseItem;